"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UncontrolledCheckbox = _interopRequireDefault(require("../Checkbox/UncontrolledCheckbox"));

var _Label = _interopRequireDefault(require("../Label"));

var _without = _interopRequireDefault(require("lodash/without"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * A component used to render a group of checkboxes.
 */


var CheckboxGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(CheckboxGroup, _Component);

  function CheckboxGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CheckboxGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CheckboxGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      var _this$props = _this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          value = _this$props$field.value,
          setFieldValue = _this$props.form.setFieldValue;
      var selectedCheckbox = e.target.id;
      var selectedCheckboxes = Array.isArray(value) ? value.slice() : [];

      if (e.target.checked && selectedCheckboxes.indexOf(selectedCheckbox) === -1) {
        selectedCheckboxes.push(selectedCheckbox);
      } else if (!e.target.checked) {
        selectedCheckboxes = (0, _without.default)(selectedCheckboxes, selectedCheckbox);
      }

      setFieldValue(name, selectedCheckboxes);
    });

    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          label = _this$props2.label,
          items = _this$props2.items,
          classes = _this$props2.classes,
          display = _this$props2.display,
          _this$props2$field = _this$props2.field,
          name = _this$props2$field.name,
          value = _this$props2$field.value;
      return _react.default.createElement("div", {
        className: classes.scaffold
      }, label && _react.default.createElement(_Label.default, null, label), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.toggles, display === "inline" && classes.inline)
      }, items.map(function (item) {
        return _react.default.cloneElement(_react.default.createElement(_UncontrolledCheckbox.default, null), {
          key: item.value,
          name: name,
          id: item.value,
          label: item.label,
          checked: value.indexOf(item.value) !== -1,
          value: item.value,
          onChange: _this2.onChange,
          disabled: item.disabled || false
        });
      })));
    }
  }]);

  return CheckboxGroup;
}(_react.Component);

_defineProperty(CheckboxGroup, "defaultProps", {
  display: "block",
  items: []
});

var styles = function styles() {
  return {
    scaffold: {
      margin: "8px auto 16px"
    },
    toggles: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      alignItems: "flex-start",
      marginLeft: "-12px"
    },
    inline: {
      flexDirection: "row"
    }
  };
};

var _default = (0, _withStyles.default)(styles, {
  name: "EuiCheckboxGroup"
})(CheckboxGroup);

exports.default = _default;